// Client-only mirror of "am I clocked in to a Watabaga shift" (from the synced Player.working flag).
// The inventory paperdoll subscribes to lock the shirt/pants slots while on shift.
type Listener = (working: boolean) => void;

class WorkingStore {
  private working = false;
  private readonly listeners = new Set<Listener>();
  get(): boolean { return this.working; }
  set(working: boolean): void {
    if (working === this.working) return;
    this.working = working;
    for (const fn of this.listeners) fn(working);
  }
  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.working);
    return () => this.listeners.delete(fn);
  }
}

export const workingStore = new WorkingStore();
